import { graphql } from "@cappelendamm/crystallize-types/search/gql";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const request = async (client, lastNode) => {
    const response = await client.search.request(graphql(`
      query GetAllFreight($shapeIdentifiers: [String!], $after: String) {
        search(
          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }
          after: $after
        ) {
          edges {
            node {
              ... on Product {
                id
                name
                matchingVariant {
                  price
                  name
                  sku
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `), {
        shapeIdentifiers: [CRYSTALLIZE_IDS.SHAPE.PRODUCT.FREIGHT.ID],
        after: lastNode,
    });
    const edges = response.search.edges;
    const nodes = edges?.map((edge) => ({
        ...edge.node.matchingVariant,
        product: {
            id: edge.node.id,
            name: edge.node.name,
        },
    }));
    return {
        hasNextPage: response.search.pageInfo.hasNextPage,
        endCursor: response.search.pageInfo.endCursor,
        nodes,
    };
};
export const getAllFreight = async ({ client }) => {
    const allFreight = [];
    let cursor = null;
    let nextPage = true;
    while (nextPage) {
        const { hasNextPage, endCursor, nodes } = await request(client, cursor ?? "");
        nextPage = hasNextPage;
        cursor = endCursor;
        if (nodes)
            allFreight.push(...nodes);
    }
    return allFreight;
};
